<div class="w-full h-full font-inter">
    <div class="w-[100%] rounded-xl border border-palette-gray-200 bg-white">
        <div class="p-3">
            <div class="flex justify-between items-center cursor-pointer" 
                (click)="handleClickExpandCollapse()"
                (mouseover)="isMouseOverExpand=true"
                (mouseleave)="isMouseOverExpand=false">
                <div class="flex items-center">
                    <span [ngClass]="{'!font-extrabold':isMouseOverExpand}"
                        class="ml-2 text-lg font-semibold text-palette-gray-900">{{ 'COMMON.PASSENGER_INFORMATION' | translate}}</span>
                    <div @slideInOut *ngIf="!isExpand" class="flex items-center ml-2">
                        {{ passengerSummary }}
                    </div>
                    
                </div>
                <i [ngClass]="{'sctr-icon-chevron-down':isExpand, 'sctr-icon-chevron-right':!isExpand, 'font-extrabold':isMouseOverExpand}" class="text-xl leading-5 text-palette-gray-500"></i>
            </div>

            <div @slideDownUp *ngIf="isExpand" class="!gap-4 p-2 grid m-0" 
                [ngClass]="passengerList.length > 1 ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2' : 'grid-cols-1'">
                <div *ngFor="let item of passengerList; let index = index"
                    class="col-span-1 rounded-lg border border-palette-gray-200 bg-palette-gray-50 !p-4 max-[767px]:mt-3 flex flex-col justify-between !gap-3"
                    [ngClass]="{'border-palette-red-200 bg-palette-red-50': item.passenger_type.toUpperCase() === 'INFANT'}">
                    <div class="flex flex-col !gap-3">
                        <div class="flex justify-between">
                            <span class="text-sm font-semibold text-palette-gray-900">
                                {{
                                    "FLIGHT.PASSENGERS." + item.passenger_type
                                    | uppercase
                                    | translate : { syntax: "" }
                                    | titlecase
                                }}
                            </span>
                            <!-- Change request status -->
                            <div *ngIf="isShowViewDetail && changeRequestList?.[currentModeView === 'DEPART' ? 0 : 1]?.[index]?.primaryStatus"
                                class="flex items-center">
                                <p class="rounded-full !px-2 !h-5 flex justify-center items-center border text-xs font-medium w-fit" 
                                    [ngClass]="{
                                        'border-palette-green-600 text-palette-green-600 bg-palette-green-50' : changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].primaryStatus?.toUpperCase() === 'RESCHEDULE_FLIGHT',
                                        'border-palette-pink-600 text-palette-pink-600 bg-palette-pink-50' : changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].primaryStatus?.toUpperCase() === 'CHANGE_PASSENGER_NAME',
                                        'border-palette-violet-600 text-palette-violet-600 bg-palette-violet-50' : changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].primaryStatus?.toUpperCase() === 'ADDITIONAL_PURCHASING',
                                        'border-palette-red-600 text-palette-red-600 bg-palette-red-50' : changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].primaryStatus?.toUpperCase() === 'CANCEL_FLIGHT',
                                    }">
                                    {{ getRequestStatus(changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].primaryStatus) | translate }}
                                </p>
                                <div class="tooltip-container">
                                    <div *ngIf="changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].uniqueStatuses?.length > 1"
                                        class="tooltip-trigger !ml-2 rounded-full !w-fit !px-2 !h-5 flex justify-center items-center border text-xs font-medium border-palette-blue-600 text-palette-blue-600 bg-palette-blue-50">
                                        +{{ changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].uniqueStatuses?.length - 1 }}
                                    </div>
                                    <div class="status-tooltip-content flex flex-col !gap-2">
                                        <ng-container *ngFor="let item of changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].uniqueStatuses">
                                            <p *ngIf="item !== changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].primaryStatus"
                                                class="rounded-full !px-2 !h-5 flex justify-center items-center border text-xs font-medium w-fit" 
                                                [ngClass]="{
                                                    'border-palette-green-600 text-palette-green-600 bg-palette-green-50' : item?.toUpperCase() === 'RESCHEDULE_FLIGHT',
                                                    'border-palette-pink-600 text-palette-pink-600 bg-palette-pink-50' : item?.toUpperCase() === 'CHANGE_PASSENGER_NAME',
                                                    'border-palette-violet-600 text-palette-violet-600 bg-palette-violet-50' : item?.toUpperCase() === 'ADDITIONAL_PURCHASING',
                                                    'border-palette-red-600 text-palette-red-600 bg-palette-red-50' : item?.toUpperCase() === 'CANCEL_FLIGHT',
                                                }">
                                                {{ getRequestStatus(item) | translate }}
                                            </p>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Full Name -->
                        <div class="flex justify-between items-center !gap-4">
                            <div class="text-sm font-normal text-palette-gray-700 whitespace-nowrap">
                                {{ "FLIGHT.PASSENGERS.FULL_NAME" | translate }}
                            </div>
                            <div class="flex-1 relative flex justify-end">
                                <div class="line-clamp-1 text-sm font-medium text-palette-gray-900"
                                    [isTruncated]="true"
                                    [tooltip]="('COMMON.' + item?.title?.toUpperCase() | translate | uppercase) + ' ' + item?.last_name?.toUpperCase() + ' ' + item?.middle_and_first_name?.toUpperCase()">
                                    {{ 'COMMON.' + item.title?.toUpperCase() | translate | uppercase }} {{ item.last_name | uppercase }} {{ item.middle_and_first_name | uppercase }}
                                </div>
                            </div>
                        </div>
                        <!-- Nationality -->
                        <div class="flex justify-between items-center !gap-4">
                            <div class="text-sm font-normal text-palette-gray-700">
                                {{ "FLIGHT.PASSENGERS.NATIONALITY" | translate }}
                            </div>
                            <div class="relative flex justify-end min-w-0">
                                <div class="line-clamp-1 text-end text-sm font-medium text-palette-gray-900 max-w-full"
                                    [isTruncated]="true" [tooltip]="item.nationality">
                                    {{ item.nationality }}
                                </div>
                            </div>
                        </div>
                        <!-- Date of birth -->
                        <div class="flex justify-between items-center !gap-4">
                            <div class="text-sm font-normal text-palette-gray-700">
                                {{ "FLIGHT.PASSENGERS.DATE_OF_BIRTH" | translate }}
                            </div>
                            <div class="truncate text-end text-sm font-medium text-palette-gray-900">
                                {{ item.date_of_birth | dateFormat }}
                            </div>
                        </div>
                        <!-- Phone Number -->
                        <div *ngIf="item?.phone" class="flex items-center gap-4">
                            <div class="text-sm font-normal text-palette-gray-700 whitespace-nowrap">
                                {{ 'COMMON.PHONE_NUMBER' | translate }}
                            </div>
                            <div class="relative min-w-0 flex-1 text-end">
                                <span 
                                    class="block w-full overflow-hidden whitespace-nowrap text-ellipsis line-clamp-1 text-sm font-medium text-palette-gray-900"
                                    [isTruncated]="true"
                                    [tooltip]="item.phone"
                                >
                                    {{ item.phone }}
                              </span>
                            </div>
                        </div>
                        <!-- Passport -->
                        <ng-container *ngIf="item.passport_identity">
                            <div class="flex justify-between items-center !gap-4">
                                <div class="text-sm font-normal text-palette-gray-700">
                                    {{ "FLIGHT.PAYMENT.PASSPORT" | translate }}
                                </div>
                                <div class="relative flex justify-end">
                                    <div class="line-clamp-1 text-end text-sm font-medium text-palette-gray-900 max-w-full"
                                        [isTruncated]="true" [tooltip]="item.country + ' • ' + item.passport_identity">
                                        {{ item.country ?? item.nationality }} • {{ item.passport_identity }}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item.passport_expiry_date" class="flex justify-between items-center !gap-4">
                                <div class="text-sm font-normal text-palette-gray-700">
                                    {{ "FLIGHT.PAYMENT.PASSPORT_EXPIRY" | translate }}
                                </div>
                                <div class="truncate text-end text-sm font-medium text-palette-gray-900">
                                    {{ item.passport_expiry_date | dateFormat}}
                                </div>
                            </div>
                        </ng-container>
                        <!-- Ticket number -->
                        <div *ngIf="item?.ticket_number" 
                            class="flex justify-between items-center !gap-4">
                            <div class="text-sm font-normal text-palette-gray-700">
                                {{ "FLIGHT.PAYMENT.TICKET_NUMBER" | translate }}
                            </div>
                            <div class="relative flex justify-end">
                                <div class="line-clamp-1 text-end text-sm font-medium text-palette-gray-900 max-w-full"
                                    [isTruncated]="true" [tooltip]="item?.ticket_number">
                                    {{ item?.ticket_number }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <button *ngIf="isModeBookingIssue && isShowViewDetail && changeRequestList?.[currentModeView === 'DEPART' ? 0 : 1]?.[index]?.history?.length"
                        (click)="onShowChooseSchedulePopup(changeRequestList[currentModeView === 'DEPART' ? 0 : 1][index].history)"
                        class="w-full rounded-lg hover:bg-[#EFF8FF] !py-1 !px-2 border 
                        border-[#1570EF] text-center text-sm !font-semibold  text-[#1570EF]">
                        {{ 'FEE.VIEW_DETAILS' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Popup Choose a schedule -->
<ng-container *ngIf="isShowChooseSchedulePopup">
    <div class="fixed top-0 left-0 bottom-0 right-0 flex justify-center items-center z-[99] bg-black bg-opacity-40 h-screen w-screen">
        <div class="w-fit h-fit min-w-[438px] max-h-[calc(100vh-40px)] rounded-2xl shadow-custom bg-white !p-6 !m-2 flex flex-col overflow-y-auto">
            <div class="flex justify-between items-center !gap-6 !mb-6">
                <h3 class="text-lg font-semibold text-palette-gray-900">
                    {{'BOOKING_ISSUE.CHOOSE_SCHEDULE' | translate}}</h3>
                <div (click)="onCloseChooseSchedulePopup()"
                    class="flex items-center justify-center w-[36px] h-[36px] hover:bg-palette-gray-100 rounded-lg cursor-pointer">
                    <i class="sctr-icon-x-close text-[20px] text-palette-gray-700"></i>
                </div>
            </div>
            <div class="flex-1 flex flex-col !gap-2 max-h-[calc(100%-204px)] overflow-y-auto !pb-2 admin-custom">
                <ng-container *ngFor="let item of historyList; let index = index; let last = last">
                    <label [for]="item.reservation_code" 
                        class="flex items-start justify-start !gap-3 !p-3 rounded-lg cursor-pointer border custom-radio
                            {{ chosenSchedule === item.reservation_code ? 'border-palette-blue-600 bg-palette-blue-50': 
                                'bg-white hover:!bg-palette-gray-100'}}">
                        <div class="flex justify-start items-start !mt-2">
                            <p-radioButton
                                [inputId]="item.reservation_code"
                                [(ngModel)]="chosenSchedule"
                                [value]="item">
                            </p-radioButton>
                        </div>
                        <div class="!mt-[4px] leading-[1.1] flex flex-col gap-[6px] justify-start font-inter w-full">
                            <p class="font-medium text-sm">{{ item.reservation_code }}</p>
                            <div class="flex justify-between items-center !gap-6 w-full">
                                <span class="text-palette-gray-500 text-sm">
                                    {{ 'BOOKING_ISSUE.UPDATE' | translate }}: {{ item?.updated_at | formatUtcZ | dateFormat : true : true }} {{ getUTCUser() }}
                                </span>
                                <p *ngIf="item.flight_issue_type && item.flight_issue_type !== 'FINDING_FLIGHT'" class="rounded-full !px-2 !h-5 flex items-center border text-xs font-medium w-fit" 
                                    [ngClass]="{
                                        'border-palette-green-600 text-palette-green-600 bg-palette-green-50' : item?.flight_issue_type?.toUpperCase() === 'RESCHEDULE_FLIGHT',
                                        'border-palette-pink-600 text-palette-pink-600 bg-palette-pink-50' : item?.flight_issue_type?.toUpperCase() === 'CHANGE_PASSENGER_NAME',
                                        'border-palette-violet-600 text-palette-violet-600 bg-palette-violet-50' : item?.flight_issue_type?.toUpperCase() === 'ADDITIONAL_PURCHASING',
                                        'border-palette-red-600 text-palette-red-600 bg-palette-red-50' : item?.flight_issue_type?.toUpperCase() === 'CANCEL_FLIGHT',
                                    }">
                                    {{ getRequestStatus(item?.flight_issue_type) | translate }}
                                </p>
                            </div>
                        </div>
                    </label>
                </ng-container>
            </div>
            <div class="flex justify-end items-center !gap-3 !pt-6">
                <button (click)="onCloseChooseSchedulePopup()"
                    class="!h-10 border border-palette-gray-300 rounded-lg !px-5 flex justify-center items-center hover:bg-palette-gray-50">
                    <p class="text-sm text-palette-gray-900 font-medium">{{ 'COMMON.CLOSE' | translate }}</p>
                </button>
                <button (click)="handleConfirmChooseSchedule()"
                    [disabled]="!chosenSchedule"
                    class="!h-10 rounded-lg !px-5 flex justify-center items-center"
                    [ngClass]="chosenSchedule ? 'bg-palette-blue-600 hover:bg-palette-blue-500' : 'bg-palette-blue-400 cursor-not-allowed'">
                    <p class="text-sm text-white font-medium">{{ 'COMMON.CONFIRM' | translate }}</p>
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isShowViewDetails">
    <app-view-details-flight
        [type]="typeViewDetails"
        [flightDetail]="flightDetail"
        [id]="chosenSchedule.reservation_code"
        (closePopupEmit)="handleCloseViewDetailsPopup()">
    </app-view-details-flight>
</ng-container>